import { ComboBoxComponent, FilteringEventArgs } from '@syncfusion/ej2-react-dropdowns';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { IForm } from '../../../../../component/admin-module/module/business-process/module/form/interface/form';
import { IDataTable } from '../../../../../component/admin-module/module/data-tables/reducer';
import { IField, IFieldAccessType, IOptionValue } from '../../../../../component/admin-module/module/users/interface/field';
import { IRootState } from '../../../../../reducers';
import { IConfigName } from '../../../type/interface/field-type-object';
import { getOption, triggerFilterOptions } from '../../object/enum-type/utils';
import { AcceptedProps } from '../../object/interface/accepted-props';
import { setTableEnumOptions } from '../../object/table-type/utils/set-table-enum-options';
import { setConstraintInitialValue } from '../../object/type/enum/util/set-constraint-initial-value';
import { TValidationType } from '../../service/field-properties.handler';
import { FieldProperties } from '../../service/field-properties.service';
import { EnumProps } from '../../service/type/enum';
import { formatEnumValidationSchema } from './utils/format-validation-schema';
import { triggerAutomationUpdateField } from './utils/trigger-automation-update-field';

interface IDropdownOption {
  key: string;
  text: string;
  value: string;
  deleted: boolean | undefined;
}

let searchFilterTimeout = setTimeout(() => { }, 1000);

const SingleEnum: React.FC<AcceptedProps> = (props) => {
  let setValueTimeout: any = 0;
  let dropdownObject: ComboBoxComponent;

  const name = props.getFieldId();
  const mountedRef = useRef(true);
  const { company } = useSelector((state: IRootState) => state.auth);
  const { userBusinessProcess, userDataTable } = useSelector((state: IRootState) => state.endUser);

  const [refresher, setRefresher] = useState(0);
  // eslint-disable-next-line
  const [hasAccessShorctut, setHasAccessShortCut] = useState(false);
  const [forceReadOnlyElement, setForceReadOnlyElement] = useState(false);
  const [triggerSearchFilter, setTriggerSearchFilter] = useState(0);

  const elementProperties = new FieldProperties(name, props.forwardedRef, new EnumProps());

  if (!elementProperties.isSet() && props.triggerFilter) {
    elementProperties.setCurrent({ ...elementProperties.current, fieldType: 'enum' })
  }

  if (props.isClearValue && elementProperties.current) {
    elementProperties.setCurrent({ ...elementProperties.current, value: '' })
  }

  const setFullDetailOfSelectedValue = (value: any) => {
    let options = getOption(props);
    if (elementProperties.current.filteredOption) {
      options = elementProperties.current.filteredOption || [];
    }
    const tempSelectedValue = options.filter((e: IOptionValue) => e.id === value);
    elementProperties.setCurrent({ ...elementProperties.current, selectedOptionFilter: tempSelectedValue });
  }

  const setDefaultValue = () => {
    if (elementProperties.hasValue()) {
      return;
    }
    let defaultValue = props.defaultValue ? props.defaultValue : '';
    if (!props.defaultValueElement && defaultValue) {
      elementProperties.setCurrent({ ...elementProperties.current, value: defaultValue as string });
      setRefresher(refresher + 1);
    }
  }

  const validateSelectedValue = () => {
    let schema = formatEnumValidationSchema(props);
    elementProperties.validate({ ...props, validationSchema: { ...schema } }, TValidationType.onBlur);
    setRefresher(refresher + 1);
  }

  const checkIfAllowedToCreate = async () => {
    let hasAccess = false;
    if (props.inputConfig.config.source && props.inputConfig.config.source.formId) {
      const myForm = userBusinessProcess.find((form: IForm) => props.inputConfig.config.source && form.id === props.inputConfig.config.source.formId)
      if (myForm) {
        hasAccess = true;
      }
    }
    if (props.inputConfig.config.source && props.inputConfig.config.source.databaseId) {
      const mydatatable = userDataTable.find((dt: IDataTable) =>
        props.inputConfig.config.source && dt.id === props.inputConfig.config.source.databaseId
        && dt.allowedAccess === 'edit'
      )
      if (mydatatable) {
        hasAccess = true;
      }
    }
    setHasAccessShortCut(hasAccess)
  }

  const resetSearchOptionData = () => {
    elementProperties.setCurrent({ ...elementProperties.current, optionsFilterSearch: '' });
    clearTimeout(searchFilterTimeout);
  }

  const triggerOnFiltering = (event: FilteringEventArgs) => {
    if (props.fieldEnumOptionUrl) {
      dropdownObject.dataSource = [];
      dropdownObject.noRecordsTemplate = 'Searching...';
      elementProperties.setCurrent({
        ...elementProperties.current,
        optionsFilterSearch: event.text
      });
      clearTimeout(searchFilterTimeout);
      searchFilterTimeout = setTimeout(() => {
        setTriggerSearchFilter(triggerSearchFilter + 1);
      }, 1000);
    }
  }

  const triggerOnFocusAndClick = (event: any) => {
    dropdownObject.showPopup();
    triggerSearchOption();
  }

  const triggerOnClose = () => {
    resetSearchOptionData();
    if (props.accessType === IFieldAccessType.Required) {
      validateSelectedValue();
    }
    if (props.reloadOnChange && props.reloadOnChange.length > 0 && props.triggerFieldReload) {
      props.triggerFieldReload(props.reloadOnChange);
    }
    triggerRelatedApplication();
    if (props.hasPageChangeRef) {
      props.hasPageChangeRef.current.hasChange = true;
    }
    if (props.throwValueOutside) {
      props.throwValueOutside()
    }
    triggerAutomation(getValue());
  }

  const triggerOnCreate = () => {
    if (props.isAddRecord) {
      if (props.flags && props.flags.indexOf('constraint') > -1) {
        setConstraintInitialValue({
          getOption,
          currentProps: props,
          setForceReadOnlyElement,
          setRefresher,
          elementProperties,
          refresher
        });
      } else {
        setDefaultValue();
      }
    }
    if (props.accessType === IFieldAccessType.Required) {
      validateSelectedValue();
    }
    checkIfAllowedToCreate();
    componentOption();
  }

  const triggerOnChange = (event: any) => {
    const { value }: { value: string } = { ...event };
    resetSearchOptionData();
    elementProperties.setCurrent({ ...elementProperties.current, value });
    setRefresher(refresher + 1);
    setFullDetailOfSelectedValue(getValue());
    if (props.triggerFilter) props.triggerFilter('');
  }

  const triggerRelatedApplication = () => {
    if (props.triggerRelatedApplication && props.configName === IConfigName.Referenced) {
      const config: any = props.inputConfig.config;
      const dataType = Object.keys(config.source).includes('formId') ? 'document' : 'database';
      props.triggerRelatedApplication({
        id: elementProperties.current.value,
        source: config.source[Object.keys(config.source).toString()],
        dataType: dataType,
        multiple: config.multiselect,
        fieldId: name
      });
    }
  }

  const triggerAutomation = (value: string) => {
    if (props.sendTriggerToParentContainer) props.sendTriggerToParentContainer();
    if (props.automationService && props.fieldCollection) {
      const field = props.fieldCollection.find((e: IField) => e.id === props.id);
      if (field) {
        props.automationService.didUpdateFieldValue(field, value);
      }
    }
  }

  const triggerSearchOption = async () => {
    if (props.fieldEnumOptionUrl && elementProperties.isSet() && !props.isUser && !props.filterElement) {
      const retOptions = await triggerFilterOptions({
        companyId: company,
        id: name,
        originalId: props.originalId,
        forwardedRef: props.forwardedRef,
        filter: elementProperties.current.optionsFilterSearch || '',
        url: props.fieldEnumOptionUrl,
        selectedValues: elementProperties.current.selectedOptionFilter || [],
        requiresFieldData: props.requiresFieldData,
        currentFieldList: props.fieldCollection || [],
        hasAllOption: (props.inputConfig.config.items.filter((e: IOptionValue) => e.id === 'all')).length > 0,
        fieldEnumOptionUrlAdditionalFieldBody: props.fieldEnumOptionUrlAdditionalFieldBody,
        type: props.inputConfig.type,
        tableId: props.tableId,
        localFilter: props.inputConfig.config.filterEnumOptions,
        enumItemsSource: props.inputConfig.config.dataSource
      });
      if (mountedRef.current) {
        elementProperties.setCurrent({ ...elementProperties.current, filteredOption: retOptions })
        triggerAutomationUpdateField({
          value: getValue(),
          removeDeletedItemInOptions,
          getOption,
          automationService: props.automationService,
          fieldCollection: props.fieldCollection,
          currentProps: props,
          elementProperties
        });
        if (props.tableFieldEnumOptionsRef && props.tableId) {
          setTableEnumOptions(props.tableFieldEnumOptionsRef, retOptions, props.tableId, name);
        }
        setRefresher(refresher + 1);
        if (setValueTimeout) clearTimeout(setValueTimeout);
        setValueTimeout = setTimeout(() => {
          componentOption();
        }, 500);
      }
    }
  }

  const getValue = () => {
    return elementProperties.current.value;
  }

  const removeDeletedItemInOptions = (option: IDropdownOption[], value: any): IDropdownOption[] => {
    return option.filter((e: IDropdownOption) => {
      let isValueAlreadySelected = false;
      if (value instanceof Array) {
        isValueAlreadySelected = (value.indexOf(e.value) > -1);
      } else {
        isValueAlreadySelected = e.value === value;
      }

      if (e.deleted && !isValueAlreadySelected) {
        return false;
      }
      return true;
    })
  }

  const componentOption = (): any[] => {
    let option = getOption(props).map((e: IOptionValue): IDropdownOption => {
      return {
        key: e.id,
        text: e.label,
        value: e.id,
        deleted: e.deleted || undefined
      }
    });
    if (elementProperties.current.filteredOption) {
      option = elementProperties.current.filteredOption.map((e: IOptionValue): IDropdownOption => {
        return {
          key: e.id,
          text: e.label,
          value: e.id,
          deleted: e.deleted || undefined
        }
      });
    }
    if (props.filterElement && props.customEnumItems && props.customEnumItems.length > 0) {
      option = props.customEnumItems.map((e: IOptionValue): IDropdownOption => {
        return {
          key: e.id,
          text: e.label,
          value: e.id,
          deleted: e.deleted || undefined
        }
      });
    }
    const options = removeDeletedItemInOptions(option, getValue());
    dropdownObject.dataSource = options as any;
    if (!options.length) {
      dropdownObject.noRecordsTemplate = 'No records found.';
    }
    dropdownObject.value = getValue();
    return options.length ? options : [];
  }

  useEffect(() => {
    if (!props.filterElement) {
      dropdownObject.showClearButton = true;
    }
    return () => {
      mountedRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (triggerSearchFilter > 0) {
      triggerSearchOption();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerSearchFilter]);

  useEffect(() => {
    if (props.filterElement && props.customEnumItems) {
      componentOption();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.customEnumItems]);

  setFullDetailOfSelectedValue(getValue());

  return <ComboBoxComponent
    id={name}
    floatLabelType="Never"
    name={name}
    allowCustom={true}
    readOnly={props.accessType === IFieldAccessType.Readonly || forceReadOnlyElement}
    placeholder={props.havePlaceholder && props.placeHolder ? props.placeHolder : ''}
    sortOrder='Ascending'
    fields={{ text: 'text', value: 'value' }}
    autofill={true}
    immediateRender
    allowFiltering
    filtering={triggerOnFiltering}
    created={triggerOnCreate}
    onChange={triggerOnChange}
    noRecordsTemplate='Loading...'
    onClick={triggerOnFocusAndClick}
    close={triggerOnClose}
    dataSource={[]}
    onFocus={triggerOnFocusAndClick}
    ref={ref => { if (ref) dropdownObject = ref }}
  />
}

export default SingleEnum;